import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Spinner = styled.span`
  animation: ${rotate} 1s linear infinite;
  width: ${(props) => props.size ? `${props.size}px` : "26px"};
  height: ${(props) => props.size ? `${props.size}px` : "26px"};
  border-width: 3px;
  border-radius: 50%;
  animation: ${rotate} 1s linear infinite;
  transform-origin: center;
  
  &.default {
    border-style: solid;
    border-right-color: #FCFCFC;
    border-bottom-color: #FCFCFC;
    border-left-color: #FCFCFC;
    border-top-color: transparent !important;
  }
`;
